module.exports = __webpack_public_path__ + "img/menuIcon28.2e59564e.png";